import { Euro } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Button, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import Product from "../Inputs/Product";
import Toggle from "../Inputs/Toggle";
import API from "../../services/API";

export default function ProductForm({onSubmit, onCancel}){

    const [product, setProduct] = useState(defaultProduct)
    const [exists, setExists] = useState(true)
    const [loading, setLoading] = useState(false)

    const handleSubmit = e => {
        e.preventDefault();

        if(!exists){

            setLoading(true)

            API.post('/products', product)
                .then(({data}) => onSubmit({...data, quantity: product.quantity}))
                .catch(e => console.lerror(e.response?.data))
                .finally(() => setLoading(false))

        }else{
            return onSubmit(product)
        }
    }

    return <form onSubmit={handleSubmit}>

        <Stack spacing={2}>

            <Typography variant='h3'>Ajouter un article</Typography>

            <Toggle 
                label="Sélectionner un produit existant"
                value={exists}
                onChange={() => {
                    setExists(!exists)
                    setProduct(defaultProduct)
                }}
            />

            {exists && 
                <Product 
                    value={product}
                    onChange={p => p ? setProduct({...p, quantity: 1}) : defaultProduct}
                />
            }

            {!exists && 
                <TextField
                    label="Nom du produit"
                    value={product.title || ''}
                    onChange={e => setProduct({...product, title: e.target.value})}
                    size='small'
                    inputProps={{maxLength: 200}}
                    required
                />
            }

            <TextField
                label='Quantité'
                type='number'
                value={product.quantity || ''}
                onChange={e => setProduct({...product, quantity: parseInt(e.target.value || 0)})}
                InputProps={{
                    inputProps: {min: 1, step: 1},
                }}
                required
                size='small'
            />

            <TextField
                label='Prix unitaire'
                type='number'
                value={product.price === 0 ? 0 : (product.price || '')}
                onChange={e => setProduct({...product, 
                    price: e.target.value !== '' ? parseFloat(e.target.value || 0) : e.target.value
                })}
                InputProps={{
                    endAdornment: <Euro color='action'/>
                }}
                inputProps={{step: 0.01, min: 0}}
                required
                size='small'
                disabled={exists}
            />

            <TextField
                label="Taux de TVA"
                value={product.taxRate.toFixed(3)}
                onChange={e => setProduct({...product, taxRate: parseFloat(e.target.value)})}
                select
                required
                size='small'
                disabled={exists}
            >
                <MenuItem value='0.000'>0%</MenuItem>
                <MenuItem value='0.055'>5.5%</MenuItem>
                <MenuItem value='0.100'>10%</MenuItem>
                <MenuItem value='0.200'>20%</MenuItem>
            </TextField>

            
            <Stack direction='row' justifyContent='flex-end' spacing={3}>

                <Button
                    color='error'
                    onClick={onCancel}
                    size='large'
                >
                    Annuler
                </Button>

                <LoadingButton
                    type='submit'
                    size='large'
                    loading={loading}
                >
                    Ajouter    
                </LoadingButton>

            </Stack>


        </Stack>

    </form>
}


const defaultProduct = {
    title: '',
    taxRate: 0,
    price: 0,
    quantity: 1,
    type: {id: 'other'}
};